export enum HealthDataSource {
	APPLE_HEALTH = 'apple_health',
	GOOGLE_FIT = 'google_fit',
	QUESTIONNAIRE = 'questionnaire',
	BIO_SCAN = 'bioscan',
	INGESTION = 'ingestion',
}
